// #/services/workflows/createNode.ts

import { v4 as uuidv4 } from 'uuid';

import { NodeType, TriggerNode, TriggerType } from '#/types/workspace';
import parseCronString from '#/utils/parseCronString';

export const CronInputSchema = {
  properties: {
    schedule: 'string',
  },
  required: ['schedule'],
  type: 'object',
};

export const CronDefaultInputValues = {
  schedule: '0 12 * * *',
};

export const createTriggerNode = (args: {
  id: string;
  position: { x: number; y: number };
  type?: NodeType;
  data: {
    uuid?: string;
    isLateral?: boolean;
    title?: string;
    triggerType: TriggerType;
    logoUrl?: string;
    inputSchema?: Record<string, any>;
    inputValues?: Record<string, any>;
  };
}): TriggerNode => {
  const {
    id,
    position,
    type: nodeType = 'turbo',
    data: {
      uuid = uuidv4(),
      isLateral = false,
      title: _title,
      triggerType,
      logoUrl = 'https://alpha.simpfi.ai/simpfinogrid.png',
      inputSchema,
      inputValues,
      // ...restData
    },
    // ...rest
  } = args;

  let cronScheduleDetail;
  if (
    triggerType === 'cron' &&
    inputValues?.schedule != null &&
    inputValues?.schedule !== ''
  ) {
    cronScheduleDetail = parseCronString(inputValues?.schedule);
  }

  let title = 'triggers',
    subline: string = triggerType,
    detail = cronScheduleDetail;
  if (_title != null && _title !== '' && _title !== title) {
    title = _title;
    subline = `triggers/${triggerType}`;
    detail = cronScheduleDetail;
  }

  return {
    // ...rest,
    id,
    position,
    type: nodeType,
    data: {
      // ...restData,
      uuid,
      type: 'trigger',
      triggerType,
      title,
      subline,
      detail,
      logoUrl,
      icons: ['FunctionIcon'],
      isLateral,
      inputSchema:
        inputSchema ?? (triggerType === 'cron' ? CronInputSchema : {}),
      inputValues: {
        ...(triggerType === 'cron' ? CronDefaultInputValues : {}),
        ...(inputValues ?? {}),
      },
    },
  };
};

export default createTriggerNode;
